<template>
  <SponsorsLogo />
  <footer class="bg-[#1A1A1A] text-white px-6 md:px-10 lg:px-40 py-10">
    <!-- Linkler -->

    <div class="flex flex-wrap justify-center gap-4 mb-6">
      <LanguageSwitcher />
      <NuxtLink
        to="/legal"
        class="px-5 py-2 border border-[#333] rounded-full hover:bg-[#333] transition"
      >
        {{ t("footer.legal") }}
      </NuxtLink>
      <NuxtLink
        to="/cookie-policy"
        class="px-5 py-2 border border-[#333] rounded-full hover:bg-[#333] transition"
      >
        {{ t("footer.cookie") }}
      </NuxtLink>
      <NuxtLink
        to="/purchase-terms"
        class="px-5 py-2 border border-[#333] rounded-full hover:bg-[#333] transition"
      >
        {{ t("footer.purchase") }}
      </NuxtLink>
      <NuxtLink
        to="/privacy-policy"
        class="px-5 py-2 border border-[#333] rounded-full hover:bg-[#333] transition"
      >
        {{ t("footer.privacy") }}
      </NuxtLink>
    </div>

    <!-- Alt metin -->
    <p class="text-center text-gray-400 text-base md:text-lg tracking-wide">
      {{ t("footer.copyright") }}
    </p>
  </footer>
</template>

<script setup>
import { useI18n } from "#imports";
import SponsorsLogo from "./SponsorsLogo.vue";
import LanguageSwitcher from "./LanguageSwitcher.vue";

const { t } = useI18n();
defineOptions({ name: "FooterSection" });
</script>
